import { render, staticRenderFns } from "./PopupImageSwitch.vue?vue&type=template&id=52c53600&"
import script from "./PopupImageSwitch.vue?vue&type=script&lang=js&"
export * from "./PopupImageSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports